import { createHistoryBrowser } from './createHistoryBrowser';

export function redirectUrl(path, title) {
  createHistoryBrowser(path, title);

  window.location.reload();
}
